<script lang="ts" setup>
import i18n from '@/lang/i18n';
import { ref, computed, watchEffect } from "vue";
import { CVR_UPLOAD_REQUEST_SELECT_RANGE } from "@/services/consts"

type rangeType = {
  start_at: Date;
  end_at: Date;
};

const emits = defineEmits(['update:modelValue'])

const props = defineProps<{
  ranges: rangeType[]
  selectedTime: string
  modelValue: string
}>();

const selectedTime = computed(() => {
  if (!props.selectedTime) {
    return null;
  }
  return new Date(props.selectedTime);
})

const selectableRange = computed(() => {
  const selectableCount = diffSelectetTimeToEndTime()
  return CVR_UPLOAD_REQUEST_SELECT_RANGE.slice(0, selectableCount)
})

function diffSelectetTimeToEndTime() {
  const range = getSelectedTimeRange()
  if (!range) {
    return 3;
  }

  let selectableMinutes = Math.ceil((range.end_at - selectedTime.value) / 1000 / 60) ;
  if (selectableMinutes > 3) {
    return 3;
  }
  return selectableMinutes;
}

function getSelectedTimeRange() {
  if (!selectedTime.value) {
    return null;
  }

  new Date(selectedTime.value)
  const ranges = props.ranges ?? []
  let range = null
  ranges.forEach((r) => {
    if (selectedTime.value >= r.start_at && selectedTime.value <= r.end_at) {
      range = r;
    }
  })
  return range;
}

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

watchEffect(() => {
  if (selectableRange.value.indexOf(props.modelValue) < 0) {
    emits('update:modelValue', selectableRange.value.slice(-1)[0]);
  }
})

</script>
<template>
  <v-select
    :label="i18n.global.t('pages.cvr_uploads.period')"
    :items="selectableRange"
    v-model="modelValue"
    :clearable="false"
  />
</template>

<style scoped>
</style>
